import { WppIconAdd, WppSkeleton, WppTypography } from '@wppopen/components-library-react'
import clsx from 'clsx'
import styles from './ActionGridButton.module.scss'
import MenuListPopUp from 'components/MenuListPopUp/MenuListPopUp'

interface ActionGridButtonProps {
  title: string
  subTitle?: string
  image?: string
  isClient?: boolean
  onBtnClick: () => void
  onMenuItemClick?: () => void
  isExpanded?: boolean
  className?: string
  isInitialising?: boolean
}

export default function ActionGridButton({
  title,
  subTitle,
  image,
  isClient,
  onBtnClick,
  onMenuItemClick,
  isExpanded = false,
  className,
  isInitialising = false,
}: ActionGridButtonProps) {
  return isInitialising ? (
    <WppSkeleton
      variant="rectangle"
      width={300}
      height={300}
      className={clsx(className, styles.reset_button_Style)}
      data-testid="client-grid-button-skeleton"
    />
  ) : (
    <button
      data-testid={`client-grid-button${isExpanded ? '-expanded' : ''}`}
      className={clsx(
        className,
        styles.reset_button_Style,
        { [styles.fadeOut]: !isClient },
        isExpanded && styles['--expanded'],
      )}
      onClick={onBtnClick}
      aria-expanded={isExpanded}
    >
      {isClient && onMenuItemClick && (
        <MenuListPopUp
          className={styles.settings}
          menuItems={[{ label: 'View', onClick: onMenuItemClick }]}
          theme="transparent-border"
        />
      )}

      {image && (
        <img src={image} alt={`${title}-logo`} height={80} className={styles.image} data-testid="client-image" />
      )}

      <WppTypography
        tag="h3"
        type={isClient ? '3xl-heading' : 'm-body'}
        className={styles.title}
        data-testid="client-name"
      >
        {!isClient && <WppIconAdd size="s" />}
        {title}
      </WppTypography>

      {subTitle && (
        <WppTypography tag="h4" type="s-strong" className={styles.subTitle} data-testid="client-sub-title">
          {subTitle}
        </WppTypography>
      )}
    </button>
  )
}
